

import { v4 as uuid } from "uuid";
import { ISsoTokenParams, ISSOToken } from "dataModels/ooauth2";

const ENV_SOURCE = window&&window._env_?window._env_:process.env;
export class Authenticator{
    private _code: string | undefined;
    private _session_state: string | undefined;
    private _ssoToken: ISSOToken|undefined;

    constructor() {
        this._ssoToken = undefined;
        this.checkUrlParams();
    }

    public get code() {
        return this._code;
    }
    public get session_state() {
        return this._session_state;
    }
    public get ssoToken():ISSOToken|undefined{
        return this._ssoToken;
    }
    public set ssoToken(token:ISSOToken|undefined){
        if(token)
            this._ssoToken = token;
    }


    public checkUrlParams() {
        const url = window.location.href;//example: "https://localhost:3000/#session_state=46916eca-6c12-4e33-bcae-bfe4e9bb0eae&code=8e1da51a-f1a6-4124-b491-94b041f6ee25.46916eca-6c12-4e33-bcae-bfe4e9bb0eae.386a99cb-dd7b-49fb-a448-13a302e01047";
        const hash = url.split('#')[1];
        const urlParams = Object.fromEntries(new URLSearchParams(hash));
        if (Object.hasOwn(urlParams, "session_state") && Object.hasOwn(urlParams, "code")) {
            //User is logged in already
            this._code = urlParams.code;
            this._session_state = urlParams.session_state;
            this.clearURL();
        }
    }

    public logoutUser () {
        const logoutUrl = new URL(ENV_SOURCE.REACT_APP_LOGOUT_BASE_URL!);
        logoutUrl.searchParams.set("client_id", ENV_SOURCE.REACT_APP_CLIENT_ID!);
        logoutUrl.searchParams.set("redirect_uri", window.location.origin); // o una pagina specifica
        
        // clean local state
        this._ssoToken = undefined;
        this._code = undefined;
        this._session_state = undefined;
    
        // redirect to logout
        window.location.replace(logoutUrl.toString());
    }

    public loginUser() {
        let loginUrl = new URL(ENV_SOURCE.REACT_APP_LOGIN_BASE_URL!);//"https://sso.c03d.snam.it/auth/realms/ADFS-PROD-DIR-OIDC/protocol/openid-connect/auth");

        const loginParams = {
            client_id: ENV_SOURCE.REACT_APP_CLIENT_ID!, 
            redirect_uri: window.location.href.toString(),
            response_mode: "fragment",
            response_type: "code",
            scope: "openid",
            nonce: uuid()
        }
        for (const [key, value] of Object.entries(loginParams)) {
            //console.log(key, value)
            loginUrl.searchParams.set(key, value);
        }
        window.location.replace(loginUrl.toString());
    }

    getSSOTokenParams( /*sessionState: string,*/): ISsoTokenParams {
        let params: ISsoTokenParams = {
            code: this.code!,
            client_id: ENV_SOURCE.REACT_APP_CLIENT_ID!, 
            client_secret: ENV_SOURCE.REACT_APP_CLIENT_SECRET!,
            grant_type: this._ssoToken ? "refresh_token" : "authorization_code",
            redirect_uri: window.location.href.toString() 
        }
        if (this._ssoToken) {
            params.refresh_token = this._ssoToken?.refresh_token;
        }
        return params;
    }

    clearURL() {
        var clean_uri = window.location.protocol + "//" + window.location.host + window.location.pathname;
    
        var hash_pos = window.location.href.indexOf("#");
        if (hash_pos > 0) {
            //var hash = window.location.href.substring(hash_pos, window.location.href.length);
            //clean_uri += hash;
            window.history.replaceState({}, document.title, clean_uri);
        }
    
       
    };

}

